import React from 'react';

const SearchResultLinkTab = ({ items }) => {
  return (
    <div className="bg-white">
      <div className="container grid gap-4 py-4 sm:grid-cols-1 md:grid-cols-4 lg:py-6">
        {items.value.map((item) => {
          return (
            <a
              className="cursor-pointer text-md text-gray-900"
              key={item.id}
              href={item.url}
            >
              {item.name}
            </a>
          );
        })}
      </div>
    </div>
  );
};
export default SearchResultLinkTab;
